"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _loyaltyGet = _interopRequireDefault(require("./loyalty-get.store"));
var _loyaltySave = _interopRequireDefault(require("./loyalty-save.store"));
var _loyaltyDelete = _interopRequireDefault(require("./loyalty-delete.store"));
var _loyaltySavePreferred = _interopRequireDefault(require("./loyalty-save-preferred.store"));
let Loyalty = /*#__PURE__*/(0, _createClass2.default)(
/**
 * constructor
 * @param {Object} initialState
 */
function Loyalty(initialState = {}) {
  (0, _classCallCheck2.default)(this, Loyalty);
  this.getLoyalty = new _loyaltyGet.default(initialState.getLoyalty);
  this.saveLoyalty = new _loyaltySave.default(initialState.saveLoyalty);
  this.deleteLoyalty = new _loyaltyDelete.default(initialState.deleteLoyalty);
  this.preferredLoyalty = new _loyaltySavePreferred.default(initialState.preferredLoyalty);
});
exports.default = Loyalty;